module.exports = {
  ACTIVE: 'ATIVO',
  NON_ACTIVE: 'INATIVO'
};
